(() => {
  const root = String(window.LoncryLinkRoot || window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const languages = new Set(window.LoncryLinkLanguages || ['en', 'fr', 'es']);
  const resource = /^(?:\/(?:pages|blogs|products|collections|policies|search|cart|account)(?:\/|$)|\/$)/;
  function localize(anchor) {
    if (anchor.hasAttribute('hreflang') || anchor.hasAttribute('download') || anchor.hasAttribute('data-no-localize')) return;
    const raw = anchor.getAttribute('href');
    if (!raw || /^(?:#|\?|mailto:|tel:|javascript:)/i.test(raw)) return;
    let url; try { url = new URL(raw, location.href); } catch (_) { return; }
    if (url.origin !== location.origin) return;
    let path = url.pathname;
    const segment = path.split('/')[1];
    if (languages.has(segment)) path = path.slice(segment.length + 1) || '/';
    if (!resource.test(path)) return;
    const target = root + path + url.search + url.hash;
    if (raw !== target) anchor.setAttribute('href', target);
  }
  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;
    if (node.matches?.('a[href]')) localize(node);
    node.querySelectorAll?.('a[href]').forEach(localize);
  }
  function start() {
    scan(document);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') localize(record.target);
      else record.addedNodes.forEach(scan);
    })).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
  }
  document.addEventListener('shopify:section:load', event => scan(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
